// extracted by mini-css-extract-plugin
export default {"container":"LocationsTable_container__MIqxD"};